<div class="modal-header">
  <h5 class="modal-title">Rename client</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<form (ngSubmit)="save()">
  <div class="modal-body">
    <label for="renameClientName" class="form-label">New name</label>
    <input id="renameClientName"
           name="renameClientName"
           class="form-control"
           autocomplete="off"
           [(ngModel)]="newName" />
  </div>
  <div class="modal-footer d-flex justify-content-end">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
    <button type="submit" class="btn btn-primary" [disabled]="!canSave">Save</button>
  </div>
</form>
